var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-input',{attrs:{"type":"date","placeholder":_vm.placeholder,"readonly":_vm.readonly},model:{value:(_vm.formattedValue),callback:function ($$v) {_vm.formattedValue=$$v},expression:"formattedValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }